/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SEO from "../components/common/seo";
import { LoginContent } from "../components/container/login";
import { persistor } from "../store";
import { selectNewProfile } from "../store/newProfile/selector";
import {
  setNewProfile,
  setNewProfileAvatar,
  setNewProfileRole,
} from "../store/newProfile/slice";
import {
  getAuthToken,
  getLastVisitedPage,
  removeAuthToken,
  setLastVisitedPage,
} from "../utils/token";

export function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authToken = getAuthToken();
  const profile = useSelector(selectNewProfile);

  const [urlParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      loginHint: params.get("loginHint"),
      redirectUri: params.get("redirectUri"),
    };
  });

  const cleanupAuthData = () => {
    const lastVisited = getLastVisitedPage();

    dispatch(setNewProfile(undefined));
    dispatch(setNewProfileRole(undefined));
    dispatch(setNewProfileAvatar(undefined));

    persistor.purge();
    sessionStorage.clear();
    localStorage.clear();

    removeAuthToken();

    if (lastVisited) {
      setLastVisitedPage(lastVisited);
    }

    if (urlParams.redirectUri) {
      setLastVisitedPage(urlParams.redirectUri);
    }
  };

  useEffect(() => {
    if (urlParams.loginHint && authToken) {
      cleanupAuthData();
      setTimeout(() => {}, 1000);
    }

    if (urlParams.redirectUri) {
      setLastVisitedPage(urlParams.redirectUri);
    }

    if (!urlParams.loginHint) {
      const from = getLastVisitedPage() || "/";

      if (authToken && profile) {
        navigate(from, { replace: true });
      }

      if (authToken && !profile) {
        navigate("/logout");
      }
    }
  }, []);

  return (
    <>
      <SEO />
      <Container maxWidth={false} disableGutters>
        <LoginContent
          loginHint={urlParams.loginHint}
          redirectUri={urlParams.redirectUri}
          cleanupAuthData={cleanupAuthData}
        />
      </Container>
    </>
  );
}
